import { useRef, useEffect } from 'react'
import lottie from 'lottie-web'
import * as S from './styles'
import loadingHav from 'assets/animations/loading-havaianas.json'

export interface LoadingHavaianasProps {
  loadingText?: string
  title?: string
  description?: string
}

export const LoadingHavaianas: React.FC<LoadingHavaianasProps> = ({
  loadingText = 'Carregando...',
  title,
  description
}) => {
  const animationContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (animationContainerRef.current)
      lottie.loadAnimation({
        container: animationContainerRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: loadingHav
      })
  }, [animationContainerRef])

  return (
    <>
      <S.AnimationContainer ref={animationContainerRef}>
        <S.LoadingText>{loadingText}</S.LoadingText>
      </S.AnimationContainer>
      {!!title && <S.LoadingTitle>{title}</S.LoadingTitle>}
      {!!description && <S.LoadingDescription>{description}</S.LoadingDescription>}
    </>
  )
}
